// extracted by mini-css-extract-plugin
export default {"root":"bar-icon-wrapper_root__YYQBi"};